import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MeetingDetails from "./meetingDetail";
import {
    getMeetingById,
    cancelMeeting,
    completeMeeting
} from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
    meetingById: state.baMeetingReducer.meetingById,
    cancel: state.baMeetingReducer.cancel,
    complete: state.baMeetingReducer.complete,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMeetingById,
            cancelMeeting,
            completeMeeting
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MeetingDetails);
